import ITabs from './tabs';
import TabPane from './tab-pane';
var Tabs = ITabs;
Tabs.TabPane = TabPane; // export { TabPane };

export default Tabs;